import React from 'react'
import { ReactComponent as EmptyIcon } from "asset/address/empty.svg";
import style from "css/address.module.css";
import { useTranslation } from 'react-i18next';

function Empty() {

    const { t } = useTranslation();
    return (
        <section className={style.empty_container}>
            <EmptyIcon />

            <article className={style.empty_article}>
                <p>{t("MESSAGE.CONTACT_PAGE_1")}</p>
                <p>{t("MESSAGE.CONTACT_PAGE_2")}</p>
            </article>

            <p className={style.empty_comment}>{t("MESSAGE.CONTACT_PAGE_3")}</p>
        </section>
    )
}

export default Empty
